<template lang="">
 <div className="w-full min-h-screen bg-site-primary ">
    <div class="flex justify-center text-4xl pt-5 ">
<a href='/'>
    LitePounds 
</a>
    </div>
    <FormKit   type="form" :actions="false" @submit="register">
    <FormKit  :classes="{steps: 'bg-site-primary', label: 'text-red-500' , wrapper: 'mx-auto'} " type="multi-step" tab-style="progress" validation='required'>

        <FormKit type='step' name='Your Profile' >
         
            <FormKit type='text' name='email' label='Your email:' validation='required'></FormKit>
            <div class='p-2'> </div>
            <FormKit type='password' name='password' label='Password:' validation="required|length:6|matches:/[^a-zA-Z]/"></FormKit>
            <div class='p-2'> </div>
            <FormKit
        type="password"
        name="password_confirm"
        label="Confirm password"
        placeholder="Confirm password"
        validation="required|confirm"
        help="Confirm your password"
      />

          
        </FormKit>

        <FormKit type='step' name='Your preferences'>
            <FormKit type='select' label='Which weight measurement system you prefer?'  name='measureWeight' validation="required" placeholder='Select your weight system preference.' :options='["kilograms", "pounds"]'></FormKit>
            <div class='p-2'> </div>
            <FormKit type='select' label='Which height measurement system do you prefer?'  placeholder='Select your height system preference.' name='measureHeight' validation="required" :options='["centimeters", "foot"]'></FormKit>
            <div class='p-2'> </div>
        </FormKit>
      
        <FormKit type='step' name='personInfo'>

            <FormKit type="number" label='Your current weight:' name='weight' validation='required'></FormKit>
            <div class='p-2'> </div>
            <FormKit type="number" label='Your current height:' name='height' validation='required'> </FormKit>
            <div class='p-2'> </div>


        </FormKit>
        <FormKit type='step' name='Goal'>
            <FormKit type='select' label='What do you want to do with your weight?' name='goalType' validation='required' placeholder= 'What do you want to do with your weight?' :options='["Lose"]'></FormKit>
            <div class='p-2'> </div>
            <FormKit type="number" label='Your weight goal:' name='goalWeight' validation='required'></FormKit>
            <div class='p-2'> </div>
       
            <template #stepNext>
        <FormKit type="submit" />
        
      </template>
             </FormKit>

         
    
    </FormKit>
</FormKit>

</div>


</template>
<script>
import UserService from '@/services/UserService';
import { MessageStore } from '@/stores/Messages';


   
export default {
    
    methods:{

    register: async function(values){
        const messagesStore = MessageStore();
        // eslint-disable-next-line no-unused-vars
        let prepareDoc = {
            email:  values['multi-step_2']['Your Profile'].email,
            password:  values['multi-step_2']['Your Profile'].password,
            confirmPassword:  values['multi-step_2']['Your Profile'].password_confirm,

            currentHeight:  values['multi-step_2']['personInfo'].height,
            currentWeight: values['multi-step_2']['personInfo'].weight,

            heightSystem:  values['multi-step_2']['Your preferences'].measureHeight === 'centimeters' ? 0 : 1,
            weightSystem:  values['multi-step_2']['Your preferences'].measureWeight === 'kilograms' ? 0 : 1, 

            weightGoal: values['multi-step_2']['Goal'].goalWeight,
            goalChoice: values['multi-step_2']['Goal'].goalType === 'Lose' ? 0 : values['multi-step_2']['Goal'].goalType === 'Hold' ? 1 : 2,



        }
       
  
        let response = await UserService.registerUser(prepareDoc);

    
        if (response.boolean === true) {

            messagesStore.setMessage(response.message, true);
            this.$router.push('/')
        }
        else {
            messagesStore.setMessage(response.message, false);
        }

    }
}
}
</script>

<style lang="css">




   
</style>
